document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-variant-option]');
  if (!input) return;
  const productRoot = input.closest('[data-product-root]');
  if (!productRoot) return;
  const variantData = JSON.parse(productRoot.querySelector('[data-variants-json]').textContent);
  const selected = Array.from(productRoot.querySelectorAll('[data-option-group]')).map((group) => {
    const checked = group.querySelector('[data-variant-option]:checked');
    return checked ? checked.value : null;
  });
  const variant = variantData.find((item) => item.options.every((option, index) => option === selected[index]));
  const formId = productRoot.dataset.productForm;
  const form = document.getElementById(formId);
  const addButton = form ? form.querySelector('[data-add-to-cart]') : null;
  if (!variant) {
    if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
    return;
  }
  const idInput = form.querySelector('input[name="id"]');
  if (idInput) idInput.value = variant.id;
  const price = productRoot.querySelector('[data-product-price]');
  if (price && typeof variant.price === 'number') {
    const currency = productRoot.dataset.currency || 'USD';
    price.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(variant.price / 100);
  }
  if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
  const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
  const mediaId = variant.featured_media && variant.featured_media.id ? variant.featured_media.id : null;
  if (mediaId) {
    const media = productRoot.querySelector(`[data-media-id="${mediaId}"]`);
    if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }
});
